module.exports = __webpack_public_path__ + "img/webmoney.97b9b224.svg";